var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVendorGroup = function SvgVendorGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#b98cb9",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 2,
    y: 2,
    fill: "#6be",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    x: 4,
    y: 4,
    fill: "#c1c1c1",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M6.5 4 6 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9,
    r: 1.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 13,
    fill: "#fff",
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c1c1",
    d: "M8 13h6v3H8z"
  }))));
};
export default SvgVendorGroup;